module.exports = __webpack_public_path__ + "static/rabbit2-dd7ce43fd2db7f16081208314599102e.png";